module.exports = __webpack_public_path__ + "static/media/ManageAccounts – Arabic.0fa4ab3c.jpg";